import { useGetHomeImagesQuery } from '../../../../../hooks/api/home/queries/useGetHomeImages.query';
import { MainCarousel } from '../../../../../pages/Home/HomePage/components/MainCarousel';

export const ProductCarouselSection = () => {
  const { data: mainCarouselImages } = useGetHomeImagesQuery({
    searchParam: {
      category: 'CAROUSEL_MAIN',
    },
  });

  if (mainCarouselImages && mainCarouselImages.length > 0) {
    <MainCarousel carouselImages={mainCarouselImages} pageType={'pdp'} />;
  }

  return <></>;
};
